import { useQuery } from '@tanstack/react-query';
import type { DashboardSummary } from '@bridgewerk/shared';
import { getApiClient } from '../../../lib/api-client.js';
import { dashboardKeys } from '../../../lib/query-keys.js';

export interface DashboardData {
  readonly summary: DashboardSummary | undefined;
  readonly isLoading: boolean;
  readonly isError: boolean;
}

export function useDashboardData(shopId: string | null): DashboardData {
  const summaryQuery = useQuery({
    queryKey: shopId ? dashboardKeys.stats(shopId) : ['dashboard', 'none'],
    queryFn: () => getApiClient().getDashboardStats(shopId ?? ''),
    enabled: !!shopId,
  });

  return {
    summary: summaryQuery.data,
    isLoading: summaryQuery.isLoading,
    isError: summaryQuery.isError,
  };
}
